<template>
  <div>
    <v-tabs
        v-model="tab_content"
        show-arrows
        style="margin-bottom:1rem;"
    >
      <v-tab
          href="#tab-0"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[0].icon }}
        </v-icon>
        <span>{{ subTabs[0].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-1"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[1].icon }}
        </v-icon>
        <span>{{ subTabs[1].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-2"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[2].icon }}
        </v-icon>
        <span>{{ subTabs[2].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-3"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[3].icon }}
        </v-icon>
        <span>{{ subTabs[3].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-4"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[4].icon }}
        </v-icon>
        <span>{{ subTabs[4].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-5"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[5].icon }}
        </v-icon>
        <span>{{ subTabs[5].title }}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab_content">
      <v-tab-item :value="'tab-'+0">
        <RoomType></RoomType>
      </v-tab-item>
      <v-tab-item :value="'tab-'+1">
        <NewRoom></NewRoom>
      </v-tab-item>
      <v-tab-item :value="'tab-'+2">
        <ApartmentBloc></ApartmentBloc>
      </v-tab-item>
      <v-tab-item :value="'tab-'+3">
        <CitedInfos></CitedInfos>
      </v-tab-item>
      <v-tab-item :value="'tab-'+4">
        <Equipment></Equipment>
      </v-tab-item>
      <v-tab-item :value="'tab-'+5">
        <StayType></StayType>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import {
  mdiOfficeBuilding, mdiOfficeBuildingOutline, mdiRoomService, mdiTooltipCheckOutline,
} from '@mdi/js'
import CitedInfos from '@/views/configuration/Cited.vue';
import StayType from '@/views/configuration/StayType.vue';
import Equipment from '@/views/configuration/Equipment.vue';
import ApartmentBloc from '@/views/configuration/AppartmentBloc.vue';
import NewRoom from '@/views/configuration/Room.vue';
import RoomType from '@/views/configuration/RoomType.vue';

export default {
  components: {
    RoomType,
    NewRoom,
    ApartmentBloc,
    Equipment,
    StayType,
    CitedInfos,
  },
  setup() {
    return {}
  },
  data() {
    return {
      subTabs: [
        { title: 'Type d\'appartement', icon: mdiRoomService },
        { title: 'Appartement', icon: mdiRoomService },
        { title: 'Immeuble', icon: mdiOfficeBuilding },
        { title: 'Infos cité', icon: mdiOfficeBuildingOutline },
        { title: 'Équipement', icon: mdiTooltipCheckOutline },
        { title: 'Type de séjour', icon: mdiRoomService },
      ],
      tab_content: null,
    }
  },
  mounted() {
    // this.loadCited()
  },
  methods: {
    addTypeRoom() {
      console.log('room add')
    },
  },
}
</script>
